import { useMemo } from 'react';
import type { WorkspaceId } from '../domain/types.ts';
import { getWorkspaceQueries, WORKSPACES } from '../seed/index.ts';
import { useWorkspaceStore } from '../stores/workspaceStore.ts';
import { useWorkspacePreferencesStore } from '../stores/workspacePreferencesStore.ts';
/** Controlled workspace selection: pass the shell's ID; this hook owns no navigation/store. */
export function useWorkspaceData(workspaceId: WorkspaceId = 'personal') {
  return useMemo(() => ({ ...getWorkspaceQueries(workspaceId), workspaces: WORKSPACES }), [workspaceId]);
}

/** Data for the workspace selected in the shell. Every console page should read through this. */
export function useCurrentWorkspace() {
  const workspaceId = useWorkspaceStore((s) => s.workspaceId);
  return useWorkspaceData(workspaceId);
}

/** The time zone every timestamp in the console renders in: the workspace setting, else the seeded workspace zone. */
export function useWorkspaceTimeZone() {
  const workspaceId = useWorkspaceStore((s) => s.workspaceId);
  const override = useWorkspacePreferencesStore((s) => s.records[workspaceId]?.timeZone);
  return override || (WORKSPACES.find((w) => w.id === workspaceId)?.timeZone ?? 'America/Los_Angeles');
}
